import React, { useCallback, useState } from 'react'
// importo el auth para poder crear usuarios en firebase
import { auth, db } from '../firebase'
// importo para poder redirigirme a otra ruta --> hacer push a otras rutas
// withRouter -> nos permite empujar al usuario a diferentes rutas
// para que withRouter ---> funciona unicamente envolviendo en el export el withRouter(Login)
import { withRouter } from 'react-router-dom'



// withRouter---> nos genera props que se llama history
const Login = (props) => {

    // creo el state para mi email ---> para relacionarlo al input se hace con el onChange()
    const [email, setEmail] = useState('prueba@prueba.com')
    // creo el state para mi contrasena
    const [pass, setPass] = useState('123456')
    // creamos un estado para pintar los errores
    const [error, setError] = useState(null)
    // para poder cambiar si es registro o login, por defecto va a estar en TRUE porque es registro
    const [esRegistro, setEsRegistro] = useState(true)



    // funcion para poder manipular los datos de mi input
    // recibe un evento (e)
    const procesarDatos = (e) => {

        // para que no haga el metodo de get automatico
        e.preventDefault()

        // vamos a validar el email
        // si lo contrario de email, lo limpiamos
        if (!email.trim()) {
            // si eso no tiene nada escrito
            // console.log('Ingrese Email');
            // seteo el error
            setError('Datos vacíos email!')
            // coloco el return para que se salga de esta funcion
            return
        }

        // vamos a validar la contrasena
        // si lo contrario la contrasena, lo limpiamos
        if (!pass.trim()) {
            // si eso no tiene nada escrito
            // console.log('Ingrese Password');
            // seteo el error
            setError('Datos vacíos en contraseña!')
            // coloco el return para que se salga de esta funcion
            return
        }

        // preguntamos por una contrasena es mayor a 6 caracteres
        if (pass.length < 6) {
            // console.log('Password menor a 6 caracteres');
            // seteo el error
            setError('Ingrese una contraseña de 6 caracteres o más')
            // coloco el return para que se salga de esta funcion
            return
        }

        // aqui es si todo esta bien
        console.log('Pasando todas las validaciones');

        // Limpio todos los errores
        setError(null)


        // llamo la funcion de mi auth, que me ayuda a registrar usuario en firebase
        // si el registro esta en verdadero
        if (esRegistro) {
            // podemos ejecutar la funcion de auth
            // hago una funcion y la llamo
            registrar()
        } else {
            // caso contrario quiere decir que registro va a estar en false por lo tanto es Login()
            login()
        }

    }



    // Hago mi funcion para registrar el usuario
    // useCallback ---> sirve para regresar un callback
    const registrar = useCallback(
        async () => {

            // toda mi funcion es aqui
            try {


                // intentamos hacer registrar el usuario
                // email y pass son mis estados como parametros
                // createUserWithEmailAndPassword(email, passs) ---> creo el usuario y contrasena
                const res = await auth.createUserWithEmailAndPassword(email, pass)
                // creo una colecion en mi firebase
                // para que no se nos cree un id aleatorio, usamos el que nos crea la respuesta = res
                // await db.collection('usuarios').doc(res.user.uid)
                // .doc() ---> es como se va a mostrar en la coleccion el identificador
                await db.collection('usuarios').doc(res.user.email).set({
                    // ESTOS SON MIS CAMPOS
                    // le pasamos el email
                    email: res.user.email,
                    uid: res.user.uid
                })

                // cuando un usuario se registre vamos a tener una coleccion especifica para un usuario que se este registrando
                // add() ---> un uid aleatorio
                await db.collection(res.user.uid).add({
                    // campos a usuario
                    name: 'Tarea de ejemplo',
                    // Date.now() --->  fecha del momento
                    fecha: Date.now()

                })



                // muestro todo de mi respuesta
                console.log(res)
                // muestro solo el res.user
                console.log(res.user)

                // limpio los campos de mi input
                setEmail('')
                setPass('')
                setError(null)

                // envio a usuario a esa ruta
                props.history.push('/admin')


            } catch (error) {
                console.log(error)

                // EMAIL NO VALIDO
                // si el error corresponde a, que cuando el email es incorrecto
                if (error.code === 'auth/invalid-email') {
                    // Pinto el error
                    // setError(error.message)
                    setError('Email no válido')
                }

                // EMAIL YA REGISTRADO
                // si el error corresponde a, que cuando el email ya esta registrado
                if (error.code === 'auth/email-already-in-use') {
                    // Pinto el error
                    // console.log(error)
                    // setError(error.message)
                    setError('Email ya registrado')
                }



            }

        },
        // llamamos a los state que estemos utilizamos
        [email, pass, props.history],
    )


    // Hago mi funcion para logear el usuario
    // useCallback ---> sirve para regresar un callback
    const login = useCallback(
        async () => {

            // toda mi funcion es aqui
            try {

                // intentamos hacer el login el usuario
                // email y pass son mis estados como parametros
                // signInWithEmailAndPassword(email, passs) ---> accedo con el usuario y contrasena
                const res = await auth.signInWithEmailAndPassword(email, pass)
                // muestro todo de mi respuesta
                console.log(res)
                // muestro solo el res.user
                console.log(res.user)

                // limpio los estados
                setEmail('')
                setPass('')
                setError(null)

                // envio a usuario a esa ruta
                props.history.push('/admin')


            } catch (error) {
                // pinto el error si es que ocurre
                console.log(error)

                // Email INCORRECTO
                // si el error corresponde a, que cuando el usuario no existe
                if (error.code === 'auth/invalid-email') {
                    // Pinto el error
                    // setError(error.message)
                    // setError('Usuario o contrasena no existe')
                    setError('Email no válido...')
                }

                // USUARIO NO ENCONTRADO
                // si el error corresponde a, que cuando el usuario no existe
                if (error.code === 'auth/user-not-found') {
                    // Pinto el error
                    // setError(error.message)
                    // setError('Usuario o contrasena no existe')
                    setError('Email no registrado...')
                }

                // auth/wrong-password
                // si el error corresponde a, que cuando el usuario no existe
                if (error.code === 'auth/wrong-password') {
                    // Pinto el error
                    // setError(error.message)
                    // setError('Usuario o contrasena no existe')
                    setError('contraseña incorrecta...')
                }


            }

        },
        // llamamos a los state que estemos utilizamos
        [email, pass, props.history],
    )






    return (
        // margin top de 5
        <div className="mt-5">
            {/* Titulo */}
            <h3 className="text-center">
                {/* cambio si es registro o login */}
                {
                    esRegistro ? 'Registro de usuarios' : 'Login de acceso'
                }
            </h3>
            <hr />
            {/* sistema de columnas y todo centrado */}
            <div className="row justify-content-center">
                {/* centrar el contenido, y que este todo en forma responsiva */}
                <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                    {/* creamos el fomrulario */}
                    <form
                        // validaciones
                        // me invento una funcion llamada---> procesarDatos
                        onSubmit={procesarDatos}
                    >

                        {/* Pintamos todos los errores en caso de que existan */}
                        {
                            // si existe algo en el error
                            error && (
                                // creo el mensaje de error
                                <div className="div alert alert-danger">
                                    {/* pinto el error */}
                                    {error}
                                </div>
                            )
                        }

                        {/* creo un input */}
                        <input
                            // tipo
                            type="email"
                            // sus clases
                            className="form-control mb-2"
                            // nombre que va a tener la caja
                            placeholder="Ingrese Email"
                            // relaciono el input con el estado
                            onChange={(e) => setEmail(e.target.value)}
                            // coloco el value para poder limpiar los campos
                            value={email}
                        />
                        <input
                            // su tipo
                            type="password"
                            // sus clases
                            className="form-control mb-2"
                            // nombre que va a tener la caja
                            placeholder="Ingrese Contraseña"
                            // relaciono el input con el estado
                            onChange={(e) => setPass(e.target.value)}
                            // coloco el value para poder limpiar los campos
                            value={pass}
                        />
                        <hr />
                        {/* creo un boton */}
                        <button
                            className="btn btn-lg btn-dark btn-block"
                            // accionador de mi furmulario ---> por eso es de tipo submit
                            // es el que nos ejecuta el metodo de procesar datos
                            type="submit"
                        >
                            {/* Cambio el texto de mi boton para que cambie con el estado */}
                            {
                                esRegistro ? 'Registrarse' : 'Acceder'
                            }
                        </button>
                        {/* creo otro boton que hace el switch */}
                        <button
                            className="btn btn-sm btn-info btn-block"
                            // tipo del boton
                            type="button"
                            // este evento me cambia el estado de mi registro al contrario
                            onClick={() => setEsRegistro(!esRegistro)}
                        >
                            {/* cambio el texto para que cambie si estripo el boton */}
                            {
                                esRegistro ? '¿Ya estas registrado?' : '¿No tienes cuenta?'
                            }
                        </button>
                        {/* creo un boton */}
                        {/* ESTE BOTON SOLO VA A APARECER EN EL LOGIN */}
                        {
                            // cuando sea login
                            !esRegistro ? (
                                <button
                                    className="btn btn-lg btn-danger btn-sm btn-block mt-2"
                                    // de tipo button para que el enter no me dispare la funcion
                                    type="button"
                                    // le hago su on lick para que ejecute la funcion
                                    onClick={() => props.history.push('/reset')}
                                >
                                    Recuperar contraseña
                                </button>
                            ) : (
                                // en caso contrario de que sea registro
                                null
                            )
                        }
                    </form>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Login)